var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3982",
    "data-name": "Rectangle 3982",
    width: 13,
    height: 14,
    transform: "translate(0.287 -0.2)",
    fill: "#2e71fc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3981",
    "data-name": "Rectangle 3981",
    width: 13,
    height: 14,
    transform: "translate(0.287 -0.2)",
    fill: "#2e71fc",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_428",
    "data-name": "Mask Group 428",
    transform: "translate(-0.287 0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_427",
    "data-name": "Mask Group 427",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M16.158,5.248v7.241a2.633,2.633,0,0,1-5.266,0V4.919a1.646,1.646,0,1,1,3.291,0v7.57a.658.658,0,0,1-1.317,0V6.235H11.88v6.254a1.646,1.646,0,0,0,3.291,0V4.919a2.633,2.633,0,0,0-5.266,0v7.57a3.621,3.621,0,1,0,7.241,0V5.248Z",
    transform: "translate(-6.983 -2.573)",
    fill: "#2e71fc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.7940eda1f26a3f3f8bd5c1be3fd38a25.svg";
export { ForwardRef as ReactComponent };